import type { NavigationStateStore } from '../types';
import { pruneStaleNavigationState } from './pruneStale';

export const clearStaleStates = (state: NavigationStateStore) => {
  pruneStaleNavigationState(state);
};
